<template>
  <div class="relative">
    <!-- SVG Definitions -->
    <svg width="0" height="0" style="position: absolute">
      <defs>
        <!-- Red Stripe Pattern -->
        <pattern
          id="redPattern"
          width="10"
          height="10"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <rect width="10" height="10" fill="#f00000" />
          <rect width="10" height="5" fill="darkred" fill-opacity="0.5" />
        </pattern>

        <!-- Blue Stripe Pattern -->
        <pattern
          id="bluePattern"
          width="10"
          height="10"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <rect width="10" height="10" fill="#006dff" />
          <rect width="10" height="5" fill="darkblue" fill-opacity="0.5" />
        </pattern>
      </defs>
    </svg>

    <!-- Label -->
    <div v-if="label" class="mb-2 text-base font-medium" :class="labelClass">
      {{ label }}
    </div>

    <!-- Progress Bar -->
    <div
      class="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700 overflow-hidden"
    >
      <div class="flex h-full">
        <div
          v-for="(segment, index) in segments"
          :key="index"
          class="h-2.5"
          :class="getSegmentClasses(segment)"
          :style="getSegmentStyle(segment)"
        >
          <svg
            v-if="segment.useRedPattern || segment.useBluePattern"
            width="100%"
            height="100%"
            class="w-full h-full"
          >
            <rect
              width="100%"
              height="100%"
              :fill="
                segment.useRedPattern ? 'url(#redPattern)' : 'url(#bluePattern)'
              "
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

type Segment = {
  percentage: number;
  bgClass?: string;
  useRedPattern?: boolean;
  useBluePattern?: boolean;
  styles?: { [key: string]: any };
};

export default defineComponent({
  name: "MultiSegmentProgressBar",
  props: {
    label: {
      type: String,
      default: ""
    },
    labelClass: {
      type: String,
      default: "dark:text-white"
    },
    defaultBgClass: {
      type: String,
      default: ""
    },
    segments: {
      type: Array as PropType<Segment[]>,
      default: () => [{ percentage: 100 }]
    }
  },
  methods: {
    getSegmentClasses(segment: Segment) {
      if (segment.useRedPattern || segment.useBluePattern) return "";
      return segment.bgClass || this.defaultBgClass;
    },
    getSegmentStyle(segment: Segment) {
      return {
        width: `${segment.percentage}%`,
        position: "relative",
        ...segment.styles
      };
    }
  }
});
</script>
